import toJSComponent from 'with-immutable-props-to-js';
import withStyles from '@material-ui/styles/withStyles';
import InProgressIcon from 'assets/in_progress_icon.svg';
import { ReactComponent as PendingIcon } from 'assets/PendingActionsFilled.svg';
import { Chip } from '@material-ui/core';
import { ActivityLogStatus } from 'features/wells/overview/activityLog/helpers/activityLog.constants';
import CheckIcon from '@material-ui/icons/Check';

const StatusChip = ({ classes, status }) => {
  switch (status) {
    case ActivityLogStatus.SCHEDULED:
      return (
        <Chip
          icon={<PendingIcon className={classes.scheduled} />}
          className={classes.chip}
          label="Scheduled"
        />
      );
    case ActivityLogStatus.IN_PROGRESS:
      return (
        <Chip
          icon={<img src={InProgressIcon} alt="" />}
          className={classes.chip}
          label="In Progress"
        />
      );
    case ActivityLogStatus.COMPLETED:
      return (
        <Chip
          icon={<CheckIcon className={classes.completed} />}
          className={classes.chip}
          label="Completed"
        />
      );
    case ActivityLogStatus.PENDING:
      return (
        <Chip
          icon={<PendingIcon className={classes.pending} />}
          className={classes.chip}
          label="Pending"
        />
      );
    case ActivityLogStatus.OVERDUE:
      return (
        <Chip
          icon={<PendingIcon className={classes.overdue} />}
          className={classes.chip}
          label="Overdue"
        />
      );
    default:
      return null;
  }
};

const styles = (theme) => {
  return {
    scheduled: {
      color: theme.palette.secondary.light,
    },
    completed: {
      color: theme.altus.status.execute,
    },
    pending: {
      color: theme.palette.warning.main,
      '& path': {
        fill: theme.palette.warning.main,
      },
    },
    overdue: {
      color: theme.palette.error.main,
      '& path': {
        fill: theme.palette.error.main,
      },
    },
    chip: {
      fontWeight: 300,
    },
  };
};

export default toJSComponent(withStyles(styles)(StatusChip));
